// extracted by mini-css-extract-plugin
export default {"ljiRed":"#ee2346","onDate":"RequiredActivitiesList_onDate__K4BB-","overdue":"RequiredActivitiesList_overdue__ZsLFv","notOverdue":"RequiredActivitiesList_notOverdue__EI0nr"};